export default {
  selectDashboardNotificationsWidget: (state) => state.notifications.widgetNotifications,
  selectAllNotifications: (state) => state.notifications.allNotifications,
  selectNotificationFilters: (state) => state.notifications.filters,
};
